import ExitToAppTwoToneIcon from '@mui/icons-material/ExitToAppTwoTone';
import { AppRoutes } from '../../../axios/endPoints';
import { handleLogOut } from '../../../store/auth-slice/auth-slice';
import GroupTwoToneIcon from '@mui/icons-material/GroupTwoTone';
import SpeedIcon from '@mui/icons-material/Speed';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import TuneIcon from '@mui/icons-material/Tune';
import PaidIcon from '@mui/icons-material/Paid';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import { Badge } from '@mui/material';
import { clearProfile } from '../../../store/profile-slice/profile-slice';

export enum Roles {
    Admin = "Admin",
    MLAdmin = "MLAdmin",
    MLUser = "MLUser",
    MLViewer = "MLViewer"
}

export enum MLRoles {
    MLAdmin = "MLAdmin",
    MLUser = "MLUser",
    MLViewer = "MLViewer"
}

export const menuItems = (t: Function, dispatch: any, navigate: Function) => [
    {
        key: 'mlCreator',
        title: t('SIDEBAR_ML_CREATOR_TEXT'),
        icon: <EmojiObjectsIcon />,
        onClickFunction: () => {
            navigate(AppRoutes.ML_CREATOR);
        },
        roles: [Roles.Admin, Roles.MLAdmin, Roles.MLUser],
        route: AppRoutes.ML_CREATOR,
        checkActiveSubscription: true
    },
    {
        key: 'mlTester',
        title: t('SIDEBAR_ML_TESTER_TEXT'),
        icon: <SpeedIcon />,
        onClickFunction: () => {
            navigate(AppRoutes.ML_TESTER);
        },
        roles: [Roles.Admin, Roles.MLAdmin, Roles.MLUser],
        route: AppRoutes.ML_TESTER,
        checkActiveSubscription: true
    },
    {
        key: 'prediction',
        title: t('SIDEBAR_PREDICTION_TEXT'),
        icon: <AnalyticsIcon />,
        onClickFunction: () => {
            navigate(AppRoutes.ML_PREDICTION);
        },

        route: AppRoutes.ML_PREDICTION,
        checkActiveSubscription: true
    },
    {
        key: 'optimization',
        title: t('SIDEBAR_OPTIMIZATION_TEXT'),
        icon: <TuneIcon />,
        onClickFunction: () => {
            navigate(AppRoutes.ML_OPTIMIZATION);
        },
        route: AppRoutes.ML_OPTIMIZATION,
        checkActiveSubscription: true
    },
    {
        key: 'tierManagement',
        title: t('SIDEBAR_TIER_MANAGEMENT'),
        icon: <PaidIcon />,
        onClickFunction: () => {
            navigate(AppRoutes.TIER_MANAGEMENT);
        },
        roles: [Roles.Admin],
        route: AppRoutes.TIER_MANAGEMENT,
        checkActiveSubscription: true
    },
    {
        key: 'userManagement',
        title: t('SIDEBAR_USER_MANAGEMENT_TEXT'),
        icon: <GroupTwoToneIcon />,
        onClickFunction: () => {
            navigate(AppRoutes.USER_MANAGEMENT);
        },
        roles: [Roles.Admin, Roles.MLAdmin],
        route: AppRoutes.USER_MANAGEMENT,
        checkActiveSubscription: true
    },
    {
        key: 'userProfile',
        title: t('SIDEBAR_PROFILE_TEXT'),
        icon: <ManageAccountsRoundedIcon />,
        onClickFunction: () => {
            navigate(AppRoutes.PROFILE);
        },
        route: AppRoutes.PROFILE
    },
    {
        key: 'colorPicker',
        title: t('SIDEBAR_COLOR_PICKER_TEXT'),
        icon: <ColorLensIcon />,
        onClickFunction: () => {
            navigate(AppRoutes.COLOR_PICKER);
        },
        route: AppRoutes.COLOR_PICKER
    },
    {
        key: 'support',
        title: t('SIDEBAR_SUPPORT'),
        onClickFunction: () => {
            navigate(AppRoutes.SUPPORT);
        },
        route: AppRoutes.SUPPORT
    },
    {
        key: 'help',
        title: t('SIDEBAR_HELP'),
        icon: <HelpCenterIcon />,
        onClickFunction: () => {
            navigate(AppRoutes.HELP);
        },
        route: AppRoutes.HELP
    },
    {
        key: 'logout',
        title: t('SIDEBAR_LOGOUT_TEXT'),
        icon: <ExitToAppTwoToneIcon />,
        onClickFunction: () => {
            dispatch(handleLogOut());
            dispatch(clearProfile());
            navigate(AppRoutes.LOG_IN);
        }
    },
    {
        key: 'mlTesterOld',
        title: t('SIDEBAR_ML_TESTER_TEXT'),
        icon: (
            <Badge
                badgeContent="OLD"
                overlap="circular"
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                sx={{
                    '& .MuiBadge-badge': {
                        background: 'var(--button-background-color)',
                        color: 'var(--button-text-color)',
                        transform: 'none',
                        top: 20,
                        left: 4,
                        fontSize: '0.6rem',
                        height: 18,
                        minWidth: 18,
                        border: '2px solid white',
                        boxSizing: 'border-box'
                    },
                }}
            >
                <SpeedIcon />
            </Badge>
        ),
        hidden: true,
        onClickFunction: () => {
            navigate(AppRoutes.ML_TESTER_OLD);
        },
        route: AppRoutes.ML_TESTER_OLD,
        checkActiveSubscription: true
    },
    {
        key: 'mlCreatorOld',
        title: t('SIDEBAR_ML_CREATOR_TEXT'),
        icon: (
            <Badge
                badgeContent="OLD"
                overlap="circular"
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                sx={{
                    '& .MuiBadge-badge': {
                        background: 'var(--button-background-color)',
                        color: 'var(--button-text-color)',
                        transform: 'none',
                        top: 20,
                        left: 4,
                        fontSize: '0.6rem',
                        height: 18,
                        minWidth: 18,
                        border: '2px solid white',
                        boxSizing: 'border-box'
                    },
                }}
            >
                <EmojiObjectsIcon />
            </Badge>
        ),
        onClickFunction: () => {
            navigate(AppRoutes.ML_CREATOR_OLD);
        },
        hidden: true,
        route: AppRoutes.ML_CREATOR_OLD,
        checkActiveSubscription: true
    },
]
